export default __webpack_public_path__ + "static/media/kitchen.f8771296.jpg";